(function() {
    'use strict';

    angular
        .module('SmartAdmin.Layout')
        .directive('cropYearPicker', CropYearPicker);
            function CropYearPicker ( ) {
            return {
                restrict: 'E',
                scope: {model: '=', options: '=', chooseOption: '&'},
                template: "<button type='button' class='btn btn-info btn-xs' " +
                "ng-class='{active: option.active}'" +
                "ng-repeat='option in options' " +
                "data-ng-click='chooseOption({item: option})'>{{option.year}} " +
                "</button>"
            };
        }
})();
